import React, { useEffect, useState } from "react";
import { Editor } from '@tinymce/tinymce-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function EditorDescLungaQUILL({
    nuovaDesc,
    initialValue,
    value,
    handleChangeEditor
}) {

    if (nuovaDesc) {
        return <ReactQuill theme="snow" value={value} onChange={handleChangeEditor} />
    } else {
        return <ReactQuill theme="snow" defaultValue={initialValue} value={value} onChange={handleChangeEditor} />
    }
}

export default EditorDescLungaQUILL;



